import { j as o } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as n } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as d } from "react";
import { TabItem as f } from "../../atoms/TabItem/TabItem.js";
import s from "./Tab.module.scss.js";
const j = ({
  activeTab: l = 0,
  iconOnly: p,
  onTabClick: a,
  orientation: e = "horizontal",
  tabs: t
}) => {
  var i;
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: n({
        [s.verticalOrientationContainer]: e === "vertical",
        "w-full": e === "horizontal"
      }),
      children: [
        /* @__PURE__ */ o.jsx(
          "div",
          {
            role: "tablist",
            className: n(s.tablistContainer, {
              [s.verticalOrientation]: e === "vertical"
            }),
            children: t == null ? void 0 : t.map((m, r) => {
              const c = {
                ...m,
                variantType: e,
                keyVal: r,
                isActiveTab: l === r,
                iconOnly: p,
                id: `tab-${r}`,
                testId: m.testId,
                role: `Tap ${r}`,
                "aria-controls": `tabpanel-${r}`,
                onClick: () => a == null ? void 0 : a(r, m)
              };
              return /* @__PURE__ */ o.jsx(
                f,
                {
                  ...c
                },
                r
              );
            })
          }
        ),
        /* @__PURE__ */ o.jsx(
          "div",
          {
            id: `tabpanel-${l}`,
            role: "tabpanel",
            "aria-labelledby": `tab-${l}`,
            tabIndex: 0,
            children: (i = t == null ? void 0 : t[l]) == null ? void 0 : i.content
          }
        )
      ]
    }
  );
}, I = d(j);
export {
  j as Tab,
  I as default
};
//# sourceMappingURL=Tab.js.map
